import Mailing from '../pages/mailing/Pages/Mailing/Mailing';
import {EVENT_TYPES} from '../redux/event/event.type';
import EventDetails from '../pages/eventDetails/cluster/Cluster';
import Groups from '../pages/tickets/groups/Groups';
import CoursePage from '../pages/tickets/coursePage/CoursePage';
import GroupPage from '../pages/tickets/groups/groupPage/GroupPage';
import Tickets from '../pages/tickets/tickets/Tickets';
import AttendancePage from '../pages/attendance/attendancePage/AttendancePage';
import ParticipantsPage from '../pages/attendance/participantsPage/ParticipantsPage';
import Team from '../pages/team/Team';
import NewTicketsEvent from '../pages/newEvent/newEvent/NewTicketsEvent';
import PixelsPage from '../pages/pixels/PixelsPage/PixelsPage';
import LeadPage from '../pages/lead/leadPage/LeadPage';
import BrandingPage from '../pages/branding/BrandingPage';
import NewEvent from '../pages/newEvent/newEvent/newEvent';
import EventRealtime from '../pages/realtime/eventRealtime/EventRealtime';
import HubDesign from '../pages/hub/hubDesign/HubDesign';
import SubscriptionPage from '../pages/subscriptions/SubscriptionPage';
import TimetablePage from '../pages/timetable/TimetablePage';
import LecturersPage from '../pages/timetable/lecturer/LecturersPage';
import {IS_NEW_TIMETABLE_UI} from '../config/config';

const isNewTimetableEvent = (event) => event?.type === EVENT_TYPES.TIMETABLE && IS_NEW_TIMETABLE_UI(event?.eid);

export const menuEvent = {
    create: {
        access: 'create_event',
        path: '/create',
        title: 'createYourEvent',
        component: 'MyIframe'
    },
    realtime: {
        access: 'access',
        path: '/realtime',
        component: EventRealtime,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.GIVECHAK]
    },
    realtimeHub: {
        access: 'access',
        path: '/realtime',
        component: HubDesign,
        events: [EVENT_TYPES.HUB]
    },
    realtimeSubscription: {
        access: 'access',
        path: '/realtime',
        component: EventRealtime,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    realtimeTimetable: {
        access: 'access',
        path: '/realtime',
        component: EventRealtime,
        events: [EVENT_TYPES.TIMETABLE]
    },
    realtimeOld: {
        access: 'access',
        path: '/realtime',
        component: 'MyIframe',
        events: [ EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE,EVENT_TYPES.COURSE,EVENT_TYPES.FRONTPAGE]
    },
    dashboard: {
        access: 'manage event',
        path: '/dashboard',
        component: 'MyIframe'
    },
    crm: {
        access: 'access_crm',
        path: '/crm',
        title: 'crm',
        subtitleItemTitle: 'crm',
        menu: ['main', 'top'],
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.SUBSCRIPTION]
    },

    'crm/timetable': {
        access: 'manage event',
        path: '/crm/timetable',
        title: 'lectures',
        subMenu: 'crm',
        component: 'MyIframe',
        events: [EVENT_TYPES.TIMETABLE]
    },
    'crm/billings': {
        access: 'access_crm',
        path: '/crm/billings',
        title: 'billings',
        subMenu: 'crm',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.SUBSCRIPTION]
    },
    event: {
        access: 'manage event',
        path: '/event',
        title: 'ofDetails',
        subtitleItemTitle: 'eventDetails',
        menu: ['main', 'top'],
        component: NewEvent,
        events: [EVENT_TYPES.HUB, EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.FRONTPAGE]
    },
    eventTimetable: {
        access: 'manage event',
        path: '/event',
        title: 'ofDetails',
        subtitleItemTitle: 'conferenceDetails',
        menu: ['main', 'top'],
        component: NewEvent,
        events: [EVENT_TYPES.TIMETABLE]
    },
    eventSubscription: {
        access: 'manage event',
        path: '/event',
        title: 'ofDetails',
        subtitleItemTitle: 'subscriptionDetails',
        menu: ['main', 'top'],
        component: NewEvent,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    eventCourse: {
        access: 'manage event',
        path: '/event',
        title: 'ofDetails',
        subtitleItemTitle: 'eventDetails',
        menu: [],
        component: NewTicketsEvent ,
        events: [EVENT_TYPES.COURSE]
    },
    'event/bookkeeping': {
        access: 'master',
        path: '/event/bookkeeping',
        title:'bookkeeping',
        menu: ['top'],
        subMenu: 'event',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE]
    },
    eventCluster: {
        access: 'manage event',
        path: '/eventCluster',
        title: 'clusterDetails',
        subtitleItemTitle: 'eventDetails',
        menu: ['main', 'top'],
        component: EventDetails,
        events: [EVENT_TYPES.CLUSTER]
    },
    'tickets/seats': {
        access: 'manage event',
        path: '/tickets/seats',
        title: 'seats',
        subMenu: 'tickets',
        menu: ['top'],
        component: 'MyIframe',
        events: [EVENT_TYPES.AREA],
        permission: 'area'
    },
    'tickets/table': {
        access: 'manage event',
        path: '/tickets/seats',
        title: 'seats',
        subMenu: 'tickets',
        component: 'MyIframe',
        events: [EVENT_TYPES.TABLE]
    },
    courses: {
        access: 'manage event',
        path: '/courses',
        title: 'courses',
        menu: ['main', 'top'],
        component: CoursePage,
        events: [EVENT_TYPES.COURSE]
    },
    'courses/groups': {
        access: 'manage event',
        path: '/courses/groups',
        title: 'groups',
        subMenu: 'courses',
        menu: ['top'],
        component: Groups,
        events: [EVENT_TYPES.COURSE]
    },
    'courses/groups/:pageId': {
        access: 'manage event',
        path: '/courses/groups/:pageId',
        subMenu: 'courses/groups',
        menu: ['subTop'],
        idDesc: 'groups',
        idParams: 'pageId',
        component: GroupPage,
        events: [EVENT_TYPES.COURSE]
    },
    'courses/coupons': {
        access: 'manage event',
        path: '/courses/coupons',
        title: 'coupons',
        subMenu: 'courses',
        component: 'MyIframe',
        events: [EVENT_TYPES.COURSE]
    },
    'courses/branding': {
        access: 'design',
        path: '/courses/branding',
        title: 'branding',
        subMenu: 'courses',
        component: BrandingPage,
        events: [EVENT_TYPES.COURSE]
    },
    'courses/branding/:messageType/:deliveryType': {
        access: 'design',
        path: '/courses/branding/:messageType/:deliveryType',
        subMenu: 'courses/branding',
        idParams: 'messageType',
        component: BrandingPage,
        events: [EVENT_TYPES.COURSE]
    },
    'courses/mailing/:messageType/:deliveryType':{
        access: 'manage event',
        path: '/courses/branding/sendTicket/whatsapp',
        title: 'ShippingAndMailing',
        component: BrandingPage,
        menu: ['main'],
        events: [EVENT_TYPES.COURSE]
    },
    'attendance': {
        access: 'attendance',
        path: '/attendance',
        title: 'attendance',
        menu: ['main', 'top'],
        component: AttendancePage,
        events: [EVENT_TYPES.COURSE]
    },
    'attendance/:pageId': {
        access: 'attendance',
        path: '/attendance/:pageId',
        subMenu: 'attendance/participants',
        idDesc:'attendance',
        idParams:'subPage',
        component: ParticipantsPage,
        events: [EVENT_TYPES.COURSE]
    },
    'tickets/groups': {
        access: 'manage event',
        path: '/tickets/groups',
        title: 'groups',
        subMenu: 'tickets',
        menu: ['top'],
        component: Groups,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER]
    },
    'tickets/groups/:pageId': {
        access: 'manage event',
        path: '/tickets/groups/:pageId',
        subMenu: 'tickets/groups',
        idDesc:'groups',
        idParams:'pageId',
        menu: ['subTop'],
        component: GroupPage,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER]
    },
    'tickets/reserved': {
        access: 'manage event',
        path: '/tickets/reserved',
        title: 'reserved',
        subMenu: 'tickets',
        component: 'MyIframe',
        events: [EVENT_TYPES.TABLE, EVENT_TYPES.AREA],
        permission: 'reserved'
    },
    'tickets/coupons': {
        access: 'manage event',
        path: '/tickets/coupons',
        title: 'coupons',
        subMenu: 'tickets',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE]
    },
    'tickets/branding': {
        access: 'design',
        path: '/tickets/branding/sendTicket/whatsapp',
        title: 'branding',
        subMenu: 'tickets',
        component: BrandingPage,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE]
    },
    'tickets/branding/:messageType/:deliveryType': {
        access: 'design',
        path: '/tickets/branding/:messageType/:deliveryType',
        subMenu: 'tickets/branding',
        idParams: 'messageType',
        component: BrandingPage,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE]
    },
    'subscription': {
        access: 'manage event',
        path: '/subscription',
        title: 'subscription',
        subtitleItemTitle: 'subscription',
        menu: ['main', 'top'],
        component: SubscriptionPage,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    // 'subscription/pricing': {
    //     access: 'manage event',
    //     path: '/subscription/pricing',
    //     title: 'pricingGroups',
    //     subMenu: 'subscription',
    //     component: SubscriptionPage, // TODO: change to pricing page
    //     events: [EVENT_TYPES.SUBSCRIPTION]
    // },
    // 'subscription/groups': {
    //     access: 'manage event',
    //     path: '/subscription/groups',
    //     title: 'groups',
    //     subMenu: 'subscription',
    //     component: SubscriptionPage, // TODO: change to groups page
    //     events: [EVENT_TYPES.SUBSCRIPTION]
    // },

    'subscription/branding': {
        access: 'design',
        path: '/subscription/branding/sendTicket/whatsapp',
        title: 'branding',
        subMenu: 'subscription',
        component: BrandingPage,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    'subscription/branding/:messageType/:deliveryType': {
        access: 'design',
        path: '/subscription/branding/:messageType/:deliveryType',
        subMenu: 'subscription/branding',
        idParams: 'messageType',
        component: BrandingPage,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    'subscription/mailing/:messageType/:deliveryType':{
        access: 'manage event',
        path: '/subscription/branding/sendTicket/whatsapp',
        title: 'ShippingAndMailing',
        component: BrandingPage,
        menu: ['main'],
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    'timetable': {
        access: 'manage event',
        path: '/timetable',
        title: 'manageLectures',
        subtitleItemTitle: 'manageLectures',
        menu: ['main', 'top'],
        component: TimetablePage,
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'timetable/tickets': {
        access: 'manage event',
        path: '/timetable/tickets',
        title: 'timetableTickets',
        subMenu: 'timetable',
        component: Tickets,
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'timetable/lecturers': {
        access: 'manage event',
        path: '/timetable/lecturers',
        title: 'timetableLecturers',
        subMenu: 'timetable',
        component: LecturersPage,
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'timetable/groups': {
        access: 'manage event',
        path: '/timetable/groups',
        title: 'groups',
        subMenu: 'timetable',
        menu: ['top'],
        component: Groups,
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'timetable/groups/:pageId': {
        access: 'manage event',
        path: '/timetable/groups/:pageId',
        subMenu: 'timetable/groups',
        idDesc: 'groups',
        idParams: 'pageId',
        menu: ['subTop'],
        component: GroupPage,
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'timetable/coupons': {
        access: 'manage event',
        path: '/timetable/coupons',
        title: 'coupons',
        subMenu: 'timetable',
        component: 'MyIframe',
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'timetable/:dateId': {
        access: 'manage event',
        path: '/timetable/:dateId',
        idDesc: 'timetable',
        idParams: 'dateId',
        component: TimetablePage,
        events: [EVENT_TYPES.TIMETABLE],
        condition: isNewTimetableEvent
    },
    'subscription/coupons': {
        access: 'manage event',
        path: '/subscription/coupons',
        title: 'coupons',
        subMenu: 'subscription',
        component: 'MyIframe',
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    'tickets': {
        access: 'manage event',
        path: '/tickets',
        title: 'tickets',
        subtitleItemTitle: 'tickets',
        menu: ['main', 'top'],
        component: Tickets,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.TIMETABLE],
        condition: (event) => !isNewTimetableEvent(event)
    },
    'mailing/:messageType/:deliveryType':{
        access: 'manage event',
        path: '/tickets/branding/sendTicket/whatsapp',
        title: 'ShippingAndMailing',
        component: BrandingPage,
        menu: ['main'],
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE]
    },
    'team': {
        access: 'manage event',
        path: '/team',
        title: 'ofTeam',
        menu: ['main'],
        component: Team,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.COURSE, EVENT_TYPES.HUB]
    },
    'teamTimetable': {
        access: 'manage event',
        path: '/team',
        title: 'conferenceTeam',
        menu: ['main'],
        component: Team,
        events: [EVENT_TYPES.TIMETABLE]
    },
    'teamSubscription': {
        access: 'manage event',
        path: '/team',
        title: 'ofTeam',
        subtitleItemTitle: 'subscriptionTeam',
        menu: ['main'],
        component: Team,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    'teamCluster': {
        access: 'manage event',
        path: '/team',
        title: 'clusterTeam',
        menu: ['main'],
        component: Team,
        events: [EVENT_TYPES.CLUSTER]
    },
    'designHub': {
        access: 'design',
        path: '/design',
        title: 'ofDesign',
        menu: ['main', 'top'],
        component: HubDesign,
        events: [EVENT_TYPES.HUB]
    },
    'designSubscription': {
        access: 'design',
        path: '/design',
        title: 'ofDesign',
        menu: ['main', 'top'],
        component: HubDesign,
        events: [EVENT_TYPES.SUBSCRIPTION]
    },
    'design': {
        access: 'design',
        path: '/design',
        title: 'ofDesign',
        menu: ['main', 'top'],
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.GIVECHAK, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.FRONTPAGE]

    },
    'publishGivechak': {
        access: 'publish',
        path: '/publishGivechak',
        title: 'publish',
        subtitleItemTitle: 'leads',
        menu: ['main'],
        component: 'MyIframe',
        events: [EVENT_TYPES.GIVECHAK]
    },
    'publishGivechak/v2': {
        access: 'publish',
        path: '/publish/v2',
        title: 'publishGivechakV2',
        subMenu: 'publishGivechak',
        component: 'MyIframe',
        events: [EVENT_TYPES.GIVECHAK]
    },
    'publishGivechak/pixels': {
        access: 'publish',
        path: '/publish/pixels',
        title: 'pixels',
        subMenu: 'publishGivechak',
        // component: 'MyIframe',
        component: PixelsPage,
        events: [EVENT_TYPES.GIVECHAK]
    },
    'publishGivechak/embed': {
        access: 'publish',
        path: '/publish/embed',
        title: 'embed',
        subMenu: 'publishGivechak',
        component: 'MyIframe',
        events: [EVENT_TYPES.GIVECHAK],
        permission: 'publish embed'
    },
    'publishGivechak/language': {
        access: 'publish',
        path: '/publish/language',
        title: 'languages',
        subMenu: 'publishGivechak',
        component: 'MyIframe',
        events: [EVENT_TYPES.GIVECHAK]

    },
    'publishGivechak/currencies': {
        access: 'master',
        path: '/publish/currencies',
        title: 'currencies',
        subMenu: 'publishGivechak',
        component: 'MyIframe',
        events: [EVENT_TYPES.GIVECHAK]
    },
    'publishGivechak/whatsapp': {
        access: 'publish',
        path: '/publish/whatsapp',
        title: 'whatsapp',
        subMenu: 'publishGivechak',
        component: 'MyIframe',
        events: [EVENT_TYPES.GIVECHAK]
    },

    'publish': {
        access: 'publish',
        path: '/publish',
        title: 'publish',
        subtitleItemTitle: 'leads',
        menu: ['main'],
        component: LeadPage,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.HUB, EVENT_TYPES.SUBSCRIPTION],
    },
    'publish/pixels': {
        access: 'publish',
        path: '/publish/pixels',
        title: 'pixels',
        subMenu: 'publish',
        // component:'MyIframe',
        component:PixelsPage,
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.HUB],
        permission:'publish pixel'
    },
    'publish/embed': {
        access: 'publish',
        path: '/publish/embed',
        title: 'embed',
        subMenu: 'publish',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.HUB],
        permission: 'publish embed'
    },
    'publish/language': {
        access: 'publish',
        path: '/publish/language',
        title: 'languages',
        subMenu: 'publish',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE]
    },
    'publish/currencies': {
        access: 'master',
        path: '/publish/currencies',
        title: 'currencies',
        subMenu: 'publish',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE],
        permission: 'currency'
    },
    'publish/whatsapp': {
        access: 'publish',
        path: '/publish/whatsapp',
        title: 'whatsapp',
        subMenu: 'publish',
        component: 'MyIframe',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.HUB, EVENT_TYPES.SUBSCRIPTION, EVENT_TYPES.GIVECHAK]
    },
    'inbox': {
        access: 'manage event',
        path: 'inbox',
        title: 'inbox',
        component: 'MyIframe'

    },
    'mailing': {
        access: 'manage event',
        path: '/mailing',
        title: 'mailing',
        events: [EVENT_TYPES.TICKET, EVENT_TYPES.CLUSTER, EVENT_TYPES.AREA, EVENT_TYPES.TIMETABLE, EVENT_TYPES.FRONTPAGE, EVENT_TYPES.LISTING, EVENT_TYPES.PRODUCT, EVENT_TYPES.TABLE, EVENT_TYPES.COURSE, EVENT_TYPES.GIVECHAK],
        component: Mailing
    },

    '404': {
        access: true,
        front: '404',
        title: 'pageNotFound'
    }

};
